import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import { ButtonContainer, DropContainer, StyledContainer } from "./styles";
import classnames from "classnames";
import Textarea, { resize } from "react-expanding-textarea";
import Card, { DEFAULT_CARD_SIZE } from "..";
import { CardContext } from "../..";
import { SET_CONTENT_ACTION, SET_DATA_ACTION } from "../../hooks/useCanvasReducer";
import { findVal } from "../../../../Utils";
import Auth from "../../../../Auth";
import FillingButton from "../../../FillingButton";
import { useToast } from "../../../ToastWrapper";

const MAX_CHARACTER_COUNT = 2500;

function OutlineCard({
  x, //
  y,
  content,
  title,
  placeholder,
  width,
  height,
  id,
  selected,
  type,
  zoom,
  generating,
  index,
  autoHeight,
  droppingOn,
  data,
}) {
  const {
    selectedCardIds, //
    setIsEditing,
    dispatch,
    isSpaceDown,
    cards,
    groups,
    canvasId,
    deselectAllCards,
  } = useContext(CardContext);

  const [loading, setLoading] = useState(false);
  const { setToast } = useToast();

  const editingRef = useRef(null);

  // true if this is the only card selected
  const onlyThisSelected = selected && selectedCardIds.length === 1;

  // upon selection logic
  useEffect(() => {
    if (!onlyThisSelected) {
      if (editingRef.current) {
        editingRef.current.blur();
      }
    }
  }, [selected, selectedCardIds]);

  // on edit start, focus and place cursor at end
  // useEffect(() => {
  //   if (editing && editingRef.current) {
  //     editingRef.current.focus();
  //     editingRef.current.selectionStart = editingRef.current.value.length;
  //   }
  // }, [editing]);

  useEffect(() => {
    if (!content || content.length === 0) {
      resize(3, editingRef.current);
    }
  }, [content]);

  // find the group related to this card and see if it's filled in
  const group = findVal(groups, (val) => !!val.cards.find((c) => c === id));

  const fillIn = useCallback(async () => {
    const url = "/api/ai/canvasOutlineCard";

    // construct prompt from the group
    if (group) {
      const outline = {};
      const headerCard = cards[group.cards[0]];
      const concept = headerCard.content;
      const beatId = data.beatId;

      group.cards.slice(1).forEach((cardId, i) => {
        const card = cards[cardId];
        outline[card.data.beatId] = card.content;
      });

      const d = {
        outline: outline,
        concept: concept,
        beatId: beatId, // the target beatId
        type: headerCard.data.type,
        canvasId,
        n: 1,
      };

      setLoading(true);

      const result = await Auth.fetchWithIdToken(url, d);
      if (result.success) {
        const content = result.texts[0];

        if (content) {
          // guard card not existing
          dispatch({
            type: SET_DATA_ACTION,
            id: id,
            data: {
              content: content,
            },
          });
          setLoading(false);
        }
      } else {
        setToast("An error occurred filling in the card.");
      }
    } else {
      throw new Error("Couldn't find a group for outline card", id);
    }
  }, [group, cards, data]);

  return (
    <Card
      onEditIntent={(e) => {
        if (onlyThisSelected) {
          // on the second click, we allow editing
          // setEditing(true);
        }
      }}
      x={x}
      y={y}
      content={content}
      width={width}
      height={height}
      minSize={autoHeight ? DEFAULT_CARD_SIZE : null} // if the user has touched the card and no longer auto height, then we relax the minsize
      id={id}
      selected={selected}
      type={type}
      zoom={zoom}
      generating={generating}
      generatable={true}
      index={index}
      autoHeight={autoHeight}
      generateCTAText="Generate options for this card"
    >
      {droppingOn && (
        <DropContainer>
          <div>
            <span>Drag and Drop to swap</span>
          </div>
        </DropContainer>
      )}

      <StyledContainer className={classnames("textarea-container", { editing: true, generating: generating, "dropping-on": !!droppingOn })}>
        {generating && (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        )}
        <div className="title">{title}</div>

        <Textarea
          maxLength={MAX_CHARACTER_COUNT}
          placeholder={placeholder || "Add text"}
          className={classnames("editable", { "edit-on": true })}
          ref={editingRef}
          disabled={isSpaceDown || generating}
          onChange={(e) => {
            dispatch({ type: SET_CONTENT_ACTION, id: id, content: e.target.value });
            e.stopPropagation();
          }}
          onBlur={(e) => setIsEditing(false)}
          onFocus={(e) => {
            setIsEditing(true);
            deselectAllCards({ exceptId: id });
          }}
          value={content}
        />
      </StyledContainer>

      {content?.length === 0 && (
        <ButtonContainer>
          <FillingButton
            disabled={loading}
            className="button"
            filling={loading}
            onClick={(e) => {
              e.preventDefault();
              console.log("test");
              fillIn();
            }}
          >
            ✨ Fill me in
          </FillingButton>
        </ButtonContainer>
      )}
    </Card>
  );
}

export default OutlineCard;
